.list--options {
  max-width: 240px;
}
.list {
  position: relative;
  overflow: hidden;
}

.loader-hidden {
  visibility: hidden;
}

.list-group {
  &:not(:last-of-type) {
    border-bottom: none;
  }
}

#company-loader {
  position: absolute;
  width: 100%;
  height: calc(100% - var(--search-input-height));
  z-index: 100;
  left: 0;
  background-color: var(--white-layout-301-level-0-elevation);

  & > .spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
}
